module.exports = __webpack_public_path__ + "img/network_news.4a9287a8.svg";